
const MapComponent = () => {
    return (
        <div id='myMapDiv' style={{height: "100%", width: "100%"}}></div> 
    )
}

export default MapComponent;
